import bs from '../dop-translations/bs';
import en from '../dop-translations/en';
import si from "../dop-translations/si";
import de from "../dop-translations/de";

export const dopTranslations: any = {
    bs,
    en,
    si,
    de
};

export const getDopTranslation = (
    lang: string,
    key: string
) => {

    return (
        dopTranslations?.[lang]?.[key] ||
        dopTranslations?.bs?.[key] ||
        key
    );
};